/**
 * 字段信息
 */
export const fieldJsonData = {

  //個人住屋資料
  housingInformationFields: [{
      label: "住址 *</br> Residential address",
      key: "detailAddress",
    },
    {
      label: "家庭住户人數 *</br> Number of domestic households",
      key: "householdsNum",
    },
    {
      label: "實用面積 *</br> Saleable area",
      key: "saleableArea",
    },
    {
      label: "住所類型*<br>Type of Residence",
      key: "residenceType",
    },

  ],
  //申請人個人生活及工作資料
  livingFormFields: [{
      label: "學歷*<br>Education",
      key: "education",
      type: "select",
      options: [],
      placeholder: "-請選擇-",
    },
    {
      label: "從事行業及職業*<br>Industry and Occupation",
      type: "textarea",
      key: "industryOccupation",
    },
    {
      label: "個人興趣或/及技能*<br> Personal Interests and/or Skills",
      type: "textarea",
      key: "interestsSkills",
    },

    {
      label: "曾否參與社區服務或擔任青年發展有關組織／團體的會員？*<br> Have you participated in community service or served as a member of organizations/groups related to youth development?",
      type: "textarea",
      key: "communityDevelopment",
    },

    {
      label: "需要搬至獨立居住環境的迫切性*<br>The urgency of an independent living environment",
      type: "textarea",
      desc: "(如工作或家庭需要等，最多500字<br>Such as work or family needs, up to 500 words)",
      key: "independentUrgency",
    },
    {
      label: "申請人期望居住PH2後之目標，以及達成目標之方法。*<br>What is your goal for living in the PH2? How do you plan to achieve it? ",
      type: "textarea",
      desc: "(最多500字 Up to 500 words)",
      key: "goalAchieve",
    },
    {
      label: "你理想中的PH2文化是怎樣的？你願意和我們一起建立屬於PH2的文化嗎？*<br>In your opinion, what does the perfect PH2 look like? Are you willing to help create a wonderful culture in the PH2 together with us?",
      type: "textarea",
      desc: "(最多500字 Up to 500 words)",
      key: "ph2Culture",
    },
  ],
  //香港地區靜態數據
  islands: [{
      value: "HKI",
      label: "香港島 Hong Kong Island",
    },
    {
      value: "Kowloon",
      label: "九龍 Kowloon",
    },
    {
      value: "NT",
      label: "新界 New Territories",
    },
  ],
  HKI: [
    "中西區 Central and Western",
    "灣仔 Wan Chai",
    "東區 Eastern",
    "南區 Souther",
  ],
  Kowloon: [
    "油尖旺 Yau Tsim Mong",
    "深水埗 Sham Shui Po",
    "九龍城 Kowloon City",
    "黃大仙 Wong Tai Sin",
    "觀塘 Kwun Tong"
  ],
  NT: [
    "葵青 Kwai Tsing",
    "荃灣 Tsuen Wan",
    "屯門 Tuen Mun",
    "元朗 Yuen Long",
    "北區 North",
    "大埔 Tai Po",
    "沙田 Sha Tin",
    "西貢 Sai Kung",
    "離島 Islands",
  ],
  residenceTypes: [
    "籠屋、板間房、木屋、鐵皮屋、艇戶<br>Cage room, Cubicle, Bedspace apartment, Wooden or tin-sheeted structure, Boat",
    "村屋／丁屋<br>VilfilterFormFieldsDatalage house/New Territories Exempted House",
    "單幢式大廈（沒有升降機）<br>Single tower (without elevators)",
    "單幢式大廈（有升降機）<br>Single tower(with elevators)",
    "屋苑（2幢或以上）、居屋、夾屋、紀律部隊宿舍、大學宿舍、公務員宿舍<br>Court (with two or more blocks), Home Ownership Housing, Sandwich 3 Class Housing, Disciplined Services Quarters, Student Hostels, Civil Servant Quarters",
    "舊式徙置大廈<br>Old resettlement estates",
    "公屋（沒有升降機）<br>Public Housing(without elevators)",
    "公屋（有升降機）<br>Public Housing(with elevators)",
    "過渡性房屋<br>Transitional Housing",
    "青年宿舍<br>Youth Hostel",
    "other",
  ],

  //文件上传表单子选项
  incomeList: [
    {
      key: "form21",
      content: "2.1 有固定僱主人士 Applicant with fixed employers",
    },
    {
      key: "form22",
      content: "2.2 沒有固定僱主人士 Applicant without fixed employers",
    },
    {
      key: "form23",
      content:
        "2.3 持有商業登記的自僱人士 Self-employed applicant with business registration",
    },
    {
      key: "form24",
      content:
        "2.4 沒有商業登記自僱人士 Self-employed applicant without business registration",
    },
    {
      key: "form25",
      content:
        "2.5 租用的士/公共小型巴士自行營業的自僱人士 Hiring taxi/public light bus for business purpose",
    },
    {
      key: "form26",
      content:
        "2.6 擁有的士/公共小型巴士/自行營業的自僱人士 Persons who own commercial vehicle (taxi/public light bus) ",
    },
    {
      key: "form27",
      content:
        "2.7 領取/支付贍養費的離婚人士 Divorced persons who receive/pay alimony ",
    },
  ],
  assetList: [
    {
      key: "form31",
      content: "3.1 持有土地/房產(非住宅用途) Land/Real Estate",
    },
    {
      key: "form32",
      content: "3.2 持有車輛 Vehicles",
    },
    {
      key: "form33",
      content:
        "3.3 持有的士/公共小型巴士牌照 Taxi/Public Light Bus Licences",
    },
    {
      key: "form34",
      content: "3.4 持有投資項目/保險產品 Investment / Insurance",
    },
    {
      key: "form35",
      content: "3.5 經營業務 Business undertakings",
    },
    {
      key: "form36",
      content: "3.6 存款、現金及借出貸款 Deposit, Cash and Loan to Others",
    },
  ],
}



// WEBPACK FOOTER //
// ./src/utils/json/formFields.js